<template>
  <el-dialog
    v-model="formVisible"
    :title="
      '实有安防设施' + (status === 1 ? '新增' : status === 2 ? '编辑' : '详情')
    "
    @close="close"
    width="30%"
  >
    <el-form
      v-if="formVisible"
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      :disabled="status === 3"
      label-width="120px"
      class="userForm"
    >
      <div style="text-align: center">
        <el-upload
          :action="'/api/hz-smart-community/sys/file/upload'"
          list-type="picture-card"
          :headers="{
            token: token,
          }"
          :show-file-list="false"
          :on-success="handlePictureCardPreview"
          :limit="1"
        >
          <el-icon v-if="!ruleForm.imageUrl"><plus /></el-icon>
          <img v-else :src="imgURL + ruleForm.imageUrl" />
        </el-upload>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="设施名称" prop="securityName">
            <el-input
              v-model="ruleForm.securityName"
              placeholder="请输入设施名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="设施类别" prop="securityType">
            <h-selectcode
              type="facilityType"
              v-model="ruleForm.securityType"
              placeholder="设施类别"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="设施型号" prop="securityModel">
            <el-input
              v-model="ruleForm.securityModel"
              placeholder="请输入设施型号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="安装地址" prop="securityAddress">
            <el-input
              v-model="ruleForm.securityAddress"
              placeholder="安装地址"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="经度" prop="longitude">
            <el-input
              v-model="ruleForm.longitude"
              placeholder="经度"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="纬度" prop="latitude">
            <el-input
              v-model="ruleForm.latitude"
              placeholder="纬度"
              style="width: 80%"
            ></el-input>
            <span
              style="cursor: pointer"
              class="map-d"
              @click="status !== 3 ? (mapVisible = true) : ''"
              >获取坐标</span
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属小区" prop="regionId">
            <el-select
              clearable
              v-model="ruleForm.regionId"
              placeholder="请选择小区"
            >
              <el-option
                v-for="item in options"
                :key="item.regionId"
                :label="item.name"
                :value="item.regionId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="comment">
            <el-input v-model="ruleForm.comment" placeholder="备注"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <h-button
        v-if="status !== 3"
        type="primary"
        @click="submitForm(ruleFormRef)"
        >保存</h-button
      >
      <h-button @click="formVisible = false">取消</h-button>
    </template>
  </el-dialog>
  <el-dialog
    v-model="mapVisible"
    :title="mapDialogTitle"
    top="5vh"
    width="70vw"
    @close="mapDialogClose"
  >
    <div class="map-box" v-if="mapVisible">
      <my-map
        ref="mapRef"
        :features="mapFeatures"
        @draw-area="drawArea"
        @click-map="clickMap"
      ></my-map>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <h-button @click="mapVisible = false">取消</h-button>
        <h-button @click="saveMapPoint">确定</h-button>
        <h-button v-if="mapFeatures === 'draw-area'" @click="redrawArea"
          >重新绘制</h-button
        >
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
} from "vue";
import { Plus } from "@element-plus/icons-vue";
// import Validate from '@/utils/validate.js';
import { ElMessage } from "element-plus";
import MyMap from "@/components/map/MyMap.vue";
import _ from "lodash";

import { regionselect } from "@/api/realHouse/realHouse.js";
import {
  securitysave,
  securityupdate,
  propertyinfo,
} from "@/api/threeSolid/threeSolid.js";
export default defineComponent({
  name: "",
  components: { Plus, MyMap },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref(null);
    const state = reactive({
      mapVisible: false,
      mapFeatures: "point-pick",
      mapDialogTitle: "获取坐标",
      pointPath: [],
      point: [],
      imgURL: window.imgURL,
      token: localStorage.getItem("token"),
      defaultPassword: "kzga110",
      formVisible: false,
      passwordType: 1,
      ruleForm: {
        imageUrl: "",
        securityName: "",
        securityType: "",
        securityModel: "",
        securityAddress: "",
        regionId: "",
        comment: "",
        longitude: "",
        latitude: "",
      },
      ruleFormBack: {},
      rules: {
        securityName: [
          {
            required: true,
            message: "请输入设施名称",
            trigger: "blur",
          },
        ],
        securityType: [
          {
            required: true,
            message: "请选择设施类别",
            trigger: "blur",
          },
        ],
        securityAddress: [
          {
            required: true,
            message: "请输入安装地址",
            trigger: "blur",
          },
        ],
        regionId: [
          {
            required: true,
            message: "请选择小区",
            trigger: "blur",
          },
        ],
        longitude: [
          {
            required: true,
            message: "请选择经度",
            trigger: "blur",
          },
        ],
        latitude: [
          {
            required: true,
            message: "请选择纬度",
            trigger: "blur",
          },
        ],
      },
      options: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // state.ruleForm
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      console.log(" setup ~ props", props, context);
      context.emit("update:modelValue", state.formVisible);
    });
    const propertyinfoAxios = async () => {
      const form = await propertyinfo(props.form.securityFacilitiesId);
      if (props.status !== 1) {
        state.ruleForm = _.cloneDeep(form.securityFacilities);
      } else {
        state.ruleForm = {};
      }
    };
    watch(
      () => state.formVisible,
      (v) => {
        if (v && props.status !== 1) {
          propertyinfoAxios();
        }
      }
    );
    // 保存表单数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          let res;
          if (props.status === 1) {
            res = await securitysave(state.ruleForm);
          } else if (props.status === 2) {
            res = await securityupdate(state.ruleForm);
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 点击地图
    const clickMap = (e, point) => {
      state.point = point;
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };
    const handlePictureCardPreview = (file) => {
      state.ruleForm.imageUrl = file.data.fileUrl;
    };
    const regionselectxQ = async () => {
      const params = {
        type: 3,
      };
      const res = await regionselect(params);
      console.log(res);
      state.options = res.data;
    };
    regionselectxQ();
    const formRef = ref(null);
    // 保存地图点位
    const saveMapPoint = () => {
      state.ruleForm.longitude = state.point[0];
      state.ruleForm.latitude = state.point[1];
      if (formRef.value) {
        if (state.mapFeatures === "draw-area") {
          // 绘制区域
          formRef.value.setPointPath(state.pointPath);
        } else if (state.mapFeatures === "point-pick") {
          // 获取点位
          formRef.value.setPoint(state.point);
        }
      }
      state.mapVisible = false;
    };
    return {
      ...refData,
      saveMapPoint,
      formRef,
      handlePictureCardPreview,
      submitForm,
      close,
      ruleFormRef,
      clickMap,
    };
  },
});
</script>
<style lang="scss" scoped>
.margLeftLabel {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
.userForm {
  img {
    width: 100%;
    height: 100%;
  }
  :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
    font-size: 16px !important;
    .el-icon {
      margin-top: 36px !important;
    }
  }
}
.map-box {
  width: 100%;
  height: 70vh;
}
.map-d {
  text-decoration: underline;
  color: #294a7c;
  margin-left: 10px;
}
</style>
